import { render, staticRenderFns } from "./StorageInTable.vue?vue&type=template&id=5eece1e2&scoped=true"
import script from "./StorageInTable.vue?vue&type=script&lang=js"
export * from "./StorageInTable.vue?vue&type=script&lang=js"
import style0 from "./StorageInTable.vue?vue&type=style&index=0&id=5eece1e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eece1e2",
  null
  
)

export default component.exports